import type { LDClient } from 'launchdarkly-react-client-sdk';
import { browserName, deviceType } from 'react-device-detect';

const getSegmentUserId = () =>
  localStorage.getItem('ajs_anonymous_id')?.replaceAll('"', '') ||
  localStorage.getItem('ajs_user_id')?.replaceAll('"', '') ||
  '';

export const identifyLDUser = (client: LDClient, isLoggedIn: boolean) => {
  const currentUserKey = sessionStorage.getItem('USER_ID');
  const userPayload = {
    location: window.location.href,
    browserName: browserName,
    deviceType: deviceType,
    province: localStorage.getItem('PROVINCE') || '',
    country: localStorage.getItem('COUNTRY') || undefined,
    hasReceivedRX: sessionStorage.getItem('HAS_RECEIVED_RX') || '',
    segmentId: getSegmentUserId(),
  };

  const existingCustom = client.getContext().custom;

  if (isLoggedIn && currentUserKey) {
    client.identify({
      kind: 'user',
      key: currentUserKey,
      custom: { ...existingCustom, ...userPayload },
    });
  } else {
    const updatedUser = client.getContext();
    updatedUser.custom = { ...existingCustom, ...userPayload };
    client.identify(updatedUser);
  }
};
